import React, { PureComponent } from 'react'
import bindAllActions from '../../common/bindAllActions'
import Loader from '../../components/Loader'
import { getDeviceLabel, getConditionLabel, getLabelForDevice, isLoggedIn } from '../../common/ambient'
import FormattedDataPoint from '../device/FormattedDataPoint'
import PropTypes from 'prop-types'
import { filter, identity, concat, append, flip, pipe, difference, pluck, uniq, find, propEq } from 'ramda'
import { ambient } from '@aw_products/ambient-weather-common'
import { TIME_ALERT_PARAM } from '../alert'
import AlertDescription from './AlertDescription'

const fdiff = flip(difference)
const alertSort = (a, b) => {
  const comp = a.param.localeCompare(b.param)
  if (comp !== 0) return comp
  if (a.threshold !== b.threshold) {
    return a.threshold < b.threshold ? -1 : 1
  }
  return a._id.localeCompare(b._id)
}

class AlertList extends PureComponent {
  static propTypes = {
    alert: PropTypes.object.isRequired,
    device: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
    alertActions: PropTypes.object.isRequired
  }

  state = {
    devicesFetching: [],
    devicesFetched: []
  }

  _checkAlertDevices () {
    const { devicesFetched, devicesFetching } = this.state
    const { deviceActions, alert, device } = this.props
    const { alerts } = alert
    const { devices } = device
    if (!alerts || !devices) {
      return
    }
    const deviceIdsToBeFetched = pipe(
      pluck('_id'),
      difference(this._alertDeviceIds()),
      fdiff(devicesFetching),
      fdiff(pluck('_id', devicesFetched))
    )(devices)
    // do fetching
    if (deviceIdsToBeFetched[0]) {
      const deviceId = deviceIdsToBeFetched[0]
      this.setState({
        devicesFetching: append(deviceId, devicesFetching)
      }, () => {
        deviceActions.getDevice(deviceId)
          .then(d => {
            if (!d) {
              d = {
                _id: deviceId,
                info: {
                  name: '{device missing}'
                }
              }
            }
            this.setState({
              devicesFetched: append(d, this.state.devicesFetched),
              devicesFetching: this.state.devicesFetching.filter(df => df !== deviceId)
            })
          })
      })
    }
  }
  _alerts() {
    const { alert } = this.props
    const { alerts } = alert
    if (!alerts) {
      return []
    }
    return alerts.filter(a => !a.alertSetId)
  }
  _alertDeviceIds() {
    return pipe(
      pluck('deviceId'),
      uniq,
      filter(Boolean)
    )(this._alerts())
  }

  _getDevice (deviceId) {
    const { devicesFetched } = this.state
    const { device } = this.props
    const { devices } = device
    return find(propEq('_id', deviceId), concat(devices || [], devicesFetched))
  }

  componentDidMount () {
    const { user, alert, alertActions } = this.props
    if (isLoggedIn(user) && !alert.alerts) {
      alertActions.fetchAlerts({
        userId: user.info._id
      })
    }
    this._checkAlertDevices()
  }

  componentDidUpdate () {
    this._checkAlertDevices()
  }

  _alert (alrt) {
    const { alertActions, device } = this.props
    // Only show delete icon for non-IFTTT alerts
    const deleteIcon = !alrt.ifttt ? (
      <a
        tabIndex='-1'
        onClick={() => {
          if (window.confirm('Delete alert?')) {
            alertActions.removeAlert(alrt)
          }
        }}
      >
        <i className='glyphicon glyphicon-trash' />
      </a>
    ) : null

    return (
      <div className='line' key={alrt._id}>
        <AlertDescription device={device} alrt={alrt} showNextDate={true} />
        {deleteIcon}
      </div>
    )
  }
  _alertGroup(device) {
    return <div key={device._id} className="alert-group">
      <h3>{getDeviceLabel(device)}</h3>
      {this._alerts()
        .filter(propEq('deviceId', device._id))
        .sort(alertSort)
        .map(this._alert.bind(this))
      }
    </div>
  }

  render () {
    const { alert } = this.props
    const { fetchAlertsPending } = alert
    const alertGroups = this._alertDeviceIds()
      .map(this._getDevice.bind(this))
      .filter(identity)
      .map(this._alertGroup.bind(this))
    return (
      <div className='list alert-alert-list'>
        {fetchAlertsPending ? <Loader /> : alertGroups}
      </div>
    )
  }
}

export default bindAllActions(AlertList)
AlertList.displayName = 'AlertList'
